export class ProductCardImages extends HTMLElement {
  constructor() {
    super();
    this.dirty = false;
  }

  get container() {
    return this.closest(".product-card__media");
  }

  get prevButton() {
    return this.container?.querySelector("[data-prev-button]");
  }

  get nextButton() {
    return this.container?.querySelector("[data-next-button]");
  }

  connectedCallback() {
    // Avoid unnecessary nesting and DOM queries if there's no content
    if (!this.innerHTML.trim()) {
      if (this.container) this.container.hidden = true;
      return;
    }

    if (!this.classList.contains("flickity")) return;

    this.initCarousel();

    if (!theme.config.isTouch) {
      this.bindHover();
    }
  }

  initCarousel() {
    this.carousel = new Flickity(
      this,
      {
        accessibility: false,
        draggable: true,
        pageDots: true,
        fade: true,
        prevNextButtons: false,
        wrapAround: true,
        setGallerySize: false,
        rightToLeft: theme.config.rtl,
        dragThreshold: 30,
      },
      {
        previous: this.prevButton,
        next: this.nextButton,
      },
    );

    this.bindNavigation();
  }

  bindNavigation() {
    // Only bind if buttons exist
    this.prevButton?.addEventListener("click", () => this.carousel.previous());
    this.nextButton?.addEventListener("click", () => {
      this.dirty = true;
      this.carousel.next();
    });
  }

  bindHover() {
    const productCard = this.container;
    if (!productCard) return;

    productCard.addEventListener("mouseenter", () => this.carousel.select(1));
    productCard.addEventListener("mouseleave", () => {
      if (!this.dirty) this.carousel.select(0);
    });
  }
}

customElements.define("product-card-images", ProductCardImages);
